import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Package, Wind } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import ArticoliSaldatrici from "@/pages/Articoli";
import EstrusioneArticoli from "@/pages/EstrusioneArticoli";

// Wrapper con due tab: Saldatrici (originale) + Estrusione (già esistente).
export default function ArticoliHub() {
    const { user, can } = useAuth();
    const isAdmin = user?.role === "admin";
    const canSal = isAdmin || can("articoli.view");
    const canEstr = isAdmin || can("art_estr.view");
    const first = canSal ? "saldatura" : (canEstr ? "estrusione" : "saldatura");
    const [tab, setTab] = useState(first);

    return (
        <div className="space-y-4">
            <Tabs value={tab} onValueChange={setTab}>
                <TabsList data-testid="tabs-articoli" className="bg-slate-900 border border-slate-800">
                    {canSal && <TabsTrigger value="saldatura" data-testid="tab-articoli-saldatura"><Package size={14} className="mr-1"/> Saldatrici</TabsTrigger>}
                    {canEstr && <TabsTrigger value="estrusione" data-testid="tab-articoli-estrusione"><Wind size={14} className="mr-1"/> Estrusione</TabsTrigger>}
                </TabsList>
                {canSal && <TabsContent value="saldatura" className="mt-4"><ArticoliSaldatrici /></TabsContent>}
                {canEstr && <TabsContent value="estrusione" className="mt-4"><EstrusioneArticoli /></TabsContent>}
            </Tabs>
        </div>
    );
}
